import React, { useEffect, useState } from "react";
import { BranchListContextImport } from "../../../../provider/branch/branch_list/BranchListContextProvider";
import { SearchBranchList } from "../../../../model/branch/BranchListModel";
import Loader from "../../../../widget/common/ui/Loader";
import Center from "../../../../widget/common/ui/Center";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import Div from "../../../../widget/common/ui/Div";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { textCase } from "../../../../service/ui/UI";
import StorageKeys from "../../../../const/StorageKeys";
import CacheStorage from "../../../../service/storage/CacheStorage";
import { useSelector } from "react-redux";
import { RootState } from "../../../../libraries/state_reducers/store";
import { routeName as routeNameSettingsChangeDefaultBranch } from "../../../settings/change_default_branch/SettingsChangeDefaultBranchScreen";
import SearchInput from "../../../../widget/common/form/SearchInput";
import { TextBlock } from "../../../../widget/common/ui/Text";
import BranchListDivisionSwitch from "./BranchListDivisionSwitch";
import NoData from "../../../../widget/common/ui/NoData";

const BranchListing = (props: { screenMobileView: boolean }) => {
  const screenMobileView: boolean = props.screenMobileView;

  const screenNameSelector = useSelector(
    (state: RootState) => state.branchList.screenName
  );

  const {
    showSearch,
    companyGroupType,
    branchList,
    getBranchList,
    onClickBranch,
    handleOnChange,
    clearSearch,
    searchValue,
    divisionTitle,
    switchDivision,
  } = BranchListContextImport();

  const [branchIdCurrent, setBranchIdCurrent] = useState<string>("");
  const [branches, setBranches] = useState<Array<SearchBranchList> | null>(
    null
  );

  const setupCurrentBranch = () => {
    let currentBranchId = CacheStorage.getValue(StorageKeys.branch_id);

    if (screenNameSelector === routeNameSettingsChangeDefaultBranch) {
      currentBranchId = CacheStorage.getValue(StorageKeys.branch_id);
    }
    setBranchIdCurrent(currentBranchId);
  };

  const chooseBranch = (branch: SearchBranchList) => {
    if (branchIdCurrent !== branch.branch_id!) {
      onClickBranch(branch);
    }
  };

  useEffect(() => {
    getBranchList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setBranches(branchList);
    setupCurrentBranch();
    // eslint-disable-next-line
  }, [branchList]);

  return (
    <>
      {branches == null ? (
        <Center className="h-100 py-3">{Loader.normal()}</Center>
      ) : (
        <>
          {showSearch && (
            <SearchInput
              name="search-branch"
              placeHolder="search"
              handleOnChange={handleOnChange}
              onClickSuffix={clearSearch}
              value={searchValue}
              autoFocus={true}
              listLogic={screenMobileView ? true : false}
            />
          )}

          {companyGroupType === "1" &&
            UtilityHelper.isNotEmpty(divisionTitle) && (
              <BranchListDivisionSwitch
                title={divisionTitle}
                switchDivision={switchDivision}
              />
            )}

          <>
            {branches.length === 0 ? (
              <NoData />
            ) : (
              <Listing fixedHieght={!screenMobileView}>
                {(branches ?? []).map((branch, key) => (
                  <ListItem key={key}>
                    <div
                      role={
                        branchIdCurrent === branch.branch_id!
                          ? "none"
                          : "button"
                      }
                      className={`${
                        branchIdCurrent === branch.branch_id!
                          ? "opacity-05"
                          : ""
                      }`}
                      onClick={() =>
                        branchIdCurrent === branch.branch_id!
                          ? {}
                          : chooseBranch(branch)
                      }
                    >
                      <Div
                        fontName="book"
                        color="theme-sublabel"
                        fontSize="13_14"
                      >
                        <TextBlock
                          fontName="bold"
                          textColor="theme-label"
                          fontSize="16_17"
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: UtilityHelper.wrapKeyword(
                                branch?.title!,
                                searchValue
                              ),
                            }}
                          />
                        </TextBlock>
                        <TextBlock
                          fontName="book"
                          textColor="theme-sublabel"
                          fontSize="13_14"
                        >
                          {textCase(branch.description!)}
                        </TextBlock>

                        {areaCityText(branch)}
                        {stateCityText(branch)}
                      </Div>
                    </div>
                  </ListItem>
                ))}
              </Listing>
            )}
          </>
        </>
      )}
    </>
  );
};

export default BranchListing;

const areaCityText = (detail: SearchBranchList) => {
  let areaCityNameArr: Array<string> = [detail.area_name!, detail.city_name!];
  areaCityNameArr = areaCityNameArr.filter((item) =>
    UtilityHelper.isNotEmpty(item)
  );

  return (
    <>
      {areaCityNameArr.length > 0 && (
        <TextBlock fontName="book" textColor="theme-sublabel" fontSize="13_14">
          {textCase(areaCityNameArr.join(" / "))}
        </TextBlock>
      )}
    </>
  );
};

const stateCityText = (detail: SearchBranchList) => {
  let stateCountryNameArr: Array<string> = [
    detail.state_name!,
    detail.country_name!,
  ];
  stateCountryNameArr = stateCountryNameArr.filter((item) =>
    UtilityHelper.isNotEmpty(item)
  );

  return (
    <>
      {stateCountryNameArr.length > 0 && (
        <TextBlock fontName="book" textColor="theme-sublabel" fontSize="13_14">
          {textCase(stateCountryNameArr.join(" / "))}
        </TextBlock>
      )}
    </>
  );
};
